import React from 'react';
import classes from './index.module.scss';
import ReplyMessageOptions from './ReplyMessageOptions';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { feedbackReportsPost, messagePost } from '../../api';
import { replyMessageNotice } from '../UI/Notifications';

const ReplyBox = ({ type, messageInfo, setReplyBoxVisibility, handleDefaultStatusCodes, setLoading }) => {
  const { id, subject, email, author } = messageInfo;
  const { register, handleSubmit } = useForm();
  const history = useHistory();
  const messageFrom = type === 'message' &&  author?.email || type === 'feedback' && email; 

  const sendMessage = (data, e) => {
    switch (type) {
      case 'feedback':
        feedbackRequest(data.body)
        break;
      case 'message':
        messageRequest(data.body)
        break;
      default:
        setLoading(false);
    }
  }

  const feedbackRequest = bodyMessage => {
    setLoading(true);
    feedbackReportsPost({feedback_id: id}, {subject: subject, body: bodyMessage})
      .then(response => { ///missnd feedback id 
        setLoading(false);
        replyMessageNotice('User Feedback');
        history.push('/user-feedback');
      })
      .catch(error => {
        handleDefaultStatusCodes(error.response.status);
      })
  }
  
  const messageRequest = bodyMessage => {
    messagePost({subject: subject, body: bodyMessage, receiver: author.id })
    .then(response => {
        setLoading(false);
        replyMessageNotice('Inbox');
        history.push('/inbox');
      })
      .catch(error => {
        handleDefaultStatusCodes(error.response.status);
      })
  }

  return (
    <div className={classes.Message_Box}>
      <div className={classes.Message_Header}>
        <h6>Subject: <b>{subject}</b></h6>
      </div>
      <div className={classes.Message_Sub_Header}>
        <h6>To: <b>{messageFrom}</b></h6>
      </div>
      <form onSubmit={handleSubmit(sendMessage)}>
        <div className={classes.Message_Content}>
          <textarea
            name="body"
            id="body"
            ref={register({ required: true })}
            className={classes.Message_Textarea}
            placeholder='Type text here...'
          ></textarea>
        </div>
        <ReplyMessageOptions 
          setReplyBoxVisibility={setReplyBoxVisibility}
          sendMessage={sendMessage}
        />
      </form>
    </div>
  )
}

export default ReplyBox;